import { createApp } from 'vue';

import { createDashboardI18n } from 'dashboard/i18n';
import * as Sentry from '@sentry/vue';
import { initializeAnalyticsEvents } from 'dashboard/helper/AnalyticsEventsHelper';
import {
  beforeSendSentryEvent,
  isExpectedNavigationFailure,
  sanitizeSentryEvent,
} from 'shared/helpers/SentryHelper';
import App from '../v3/App.vue';
import router, { initalizeRouter } from '../v3/views/index';
import store from '../v3/store';
import FluentIcon from 'shared/components/FluentIcon/DashboardIcon.vue';

const mountWhenReady = app => {
  const mount = () => app.mount('#app');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
};

const bootstrap = async () => {
  const i18n = await createDashboardI18n(window.chatwootConfig?.selectedLocale);
  const app = createApp(App);
  app.use(i18n);
  app.use(store);
  app.use(router);
  app.component('fluent-icon', FluentIcon);

  if (window.errorLoggingConfig) {
    Sentry.init({
      app,
      dsn: window.errorLoggingConfig,
      environment: window.sentryConfig?.environment,
      release: window.sentryConfig?.release || undefined,
      tracesSampleRate: window.sentryConfig?.tracesSampleRate ?? 0,
      sendDefaultPii: false,
      beforeSend: beforeSendSentryEvent,
      beforeSendTransaction: sanitizeSentryEvent,
      denyUrls: [
        /^chrome:\/\//i,
        /chrome-extension:/i,
        /extensions\//i,
        /file:\/\//i,
        /safari-web-extension:/i,
        /safari-extension:/i,
      ],
      integrations: [Sentry.browserTracingIntegration({ router })],
      ignoreErrors: [
        'ResizeObserver loop completed with undelivered notifications',
      ],
    });
  }

  // Authentication pages need analytics identity wiring, but not dashboard-
  // only audio or widget identity events from scriptHelpers.
  initializeAnalyticsEvents();
  initalizeRouter();
  mountWhenReady(app);
};

bootstrap().catch(error => {
  if (!isExpectedNavigationFailure(error)) Sentry.captureException(error);
});
